import { render, staticRenderFns } from "./no-discount.vue?vue&type=template&id=6984b4a0&scoped=true&"
import script from "./no-discount.vue?vue&type=script&lang=js&"
export * from "./no-discount.vue?vue&type=script&lang=js&"
import style0 from "./no-discount.vue?vue&type=style&index=0&id=6984b4a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6984b4a0",
  null
  
)

export default component.exports